<template>
  <div
      v-if="panel"
      :class="{ 'is-invalid': !isValid }"
      class="cp-hex">
    <label
        :class="{ 'has-prefix': !!$slots.prefix }"
        class="cp-hex__field">
      <slot name="prefix"/>
      <input
          :value="modelColor"
          class="cp-hex__input"
          spellcheck="false"
          autocomplete="off"
          aria-label="Hex color"
          @keyup.enter="updateColorfromInput"
      >
    </label>
    <span
        v-tooltip="'Invalid Color Code entered'"
        v-if="!isValid"
        class="cp-hex__alert">
      <svg
          width="18"
          height="18"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="2"
          stroke-linecap="round"
          aria-hidden="true">
        <circle
            cx="12"
            cy="12"
            r="9.5"/>
        <path d="M12 11v6"/>
        <path d="M12 7.5v.01"/>
      </svg>
    </span>
  </div>
  <div
      v-else
      class="color-type">
    <input
        :value="modelColor"
        class="value"
        @keyup.enter="updateColorfromInput"
    >
    <span
        v-tooltip="'Invalid Color Code entered'"
        v-if="!isValid"
        class="color-alert"><i class="fa fa-exclamation-circle"/></span>
  </div>
</template>

<script>
import chroma from 'chroma-js';

export default {
  props: {
    name: {
      type:    String,
      default: '',
    },
    color: {
      type:    String,
      default: '',
    },
    panel: {
      type:    Boolean,
      default: false,
    },
  },
  data() {
    return { isValid: chroma.valid(this.color) };
  },
  computed: {
    modelColor() {
      return this.color;
    },
  },
  watch: {
    color(newVal, oldVal) { // watch it
      this.isValid = chroma.valid(newVal);
    },
  },
  methods: {
    updateColorfromInput(e) {
      const value = e.target.value;
      if (chroma.valid(value)) {
        this.$emit('inputColor', chroma(value).hex());
        this.isValid = true;
      } else {
        this.isValid = false;
      }
    },
  },
};
</script>
